module.exports = __webpack_public_path__ + "img/wheel.56b69649.png";